"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.difference = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const _ = require("lodash");
const difference = (origObj, newObj) => {
    function changes(newObj, origObj) {
        let arrayIndexCounter = 0;
        return _.transform(newObj, function (result, value, key) {
            if (!_.isEqual(value, origObj[key])) {
                const resultKey = _.isArray(origObj) ? arrayIndexCounter++ : key;
                result[resultKey] =
                    _.isObject(value) && _.isObject(origObj[key])
                        ? changes(value, origObj[key])
                        : value;
            }
        });
    }
    return changes(newObj, origObj);
};
exports.difference = difference;
